<template>
  <div class="footer__logo">
    <sc-link :field="this.fields.LinkUrl" :editable="false">
      <sc-image :media="fields.LogoImage" :editable="false" />
    </sc-link>
  </div>
</template>

<script>
import { Image, Link, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'FooterLogo',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        LogoImage: {},
        LinkUrl: {},
      }),
    },
  },
  components: {
    ScImage: Image,
    ScLink: Link,
  },
  computed: {
    isInternal() {
      if (this.linkField.value.linktype == 'internal') {
        return true;
      } else {
        return false;
      }
    },
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
  },
};
</script>
<style lang="scss" scoped>
.footer__logo {
  padding: 12px 16px 0;
  a {
    padding: 0;
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    padding: 12px 0 0;

    img {
      max-width: 50%;
      padding-right: 12px;
    }
  }
}
</style>
